import img from "../../assets/about.png";
import { BiLeaf } from "react-icons/bi";
import { FaArrowRightLong } from "react-icons/fa6";
import { FiClock, FiFileText, FiMapPin, FiShield } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="container mx-auto mb-12 px-4">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl text-center mb-16 font-times text-black">
          About Us
        </h2>

        {/* Main Grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-start">

          {/* IMAGE */}
          <div className="relative">
            <img
              src={img}
              alt="about"
              className="w-full h-[520px] object-cover rounded-xl"
            />

            {/* Experience Badge */}
            <div className="absolute -bottom-6 left-6 bg-white shadow-xl rounded-xl px-5 py-3 flex items-center gap-3">

              <div className="w-10 h-10 bg-[#45A3011A] rounded-full flex items-center justify-center text-[#45A301] font-bold">
                <BiLeaf  className="w-5 h-5"/>
              </div>

              <div>
                <h4 className="font-semibold text-lg text-[#0F172A]">
                  30+
                </h4>
                <p className="text-xs text-[#64748B]">
                  Years Experience
                </p>
              </div>

            </div>
          </div>

          {/* CONTENT */}
          <div className="pt-2">

            <span className="text-xs bg-[#45A3011A] text-[#45A301] px-4 py-1.5 rounded-full">
              About KL Property
            </span>

            <h3 className="text-3xl md:text-4xl mt-4 mb-4 text-[#0F172A] leading-snug font-times">
              Trusted Land & Property Experts in Idukki
            </h3>

            <p className="text-[#475569] mb-10 leading-relaxed text-sm md:text-base">
              Specializing in Kerala hill plantations and agricultural land,
              KL Property brings decades of local expertise to help you find
              the perfect estate. From cardamom plantations in Idukki to
              sprawling tea estates, we ensure clear documentation and
              trusted guidance.
            </p>

            {/* FEATURES */}
            <div className="grid sm:grid-cols-2 gap-5">

              {/* 1 */}
              <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] shadow-sm">
                
                <div className="w-10 h-10 bg-[#45A3011A] rounded-lg flex items-center justify-center text-[#45A301] mb-4">
                  <FiClock />
                </div>

                <h4 className="font-semibold mb-2 text-[#1F2937]">
                  30+ Years Service
                </h4>
                <p className="text-sm text-[#6B7280]">
                  Decades of dedicated service in Kerala real estate market.
                </p>
              </div>

              {/* 2 */}
              <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] shadow-sm">
                
                <div className="w-10 h-10 bg-[#45A3011A] rounded-lg flex items-center justify-center text-[#45A301] mb-4">
                  <FiMapPin />
                </div>

                <h4 className="font-semibold mb-2 text-[#1F2937]">
                  Local Expertise
                </h4>
                <p className="text-sm text-[#6B7280]">
                  Deep understanding of Idukki and surrounding plantation areas.
                </p>
              </div>

              {/* 3 */}
              <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] shadow-sm">
                
                <div className="w-10 h-10 bg-[#45A3011A] rounded-lg flex items-center justify-center text-[#45A301] mb-4">
                  <FiFileText />
                </div>

                <h4 className="font-semibold mb-2 text-[#1F2937]">
                  Clear Title
                </h4>
                <p className="text-sm text-[#6B7280]">
                  Hassle-free legal processes and transparent paperwork.
                </p>
              </div>

              {/* 4 */}
              <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] shadow-sm">
                
                <div className="w-10 h-10 bg-[#45A3011A] rounded-lg flex items-center justify-center text-[#45A301] mb-4">
                  <FiShield />
                </div>

                <h4 className="font-semibold mb-2 text-[#1F2937]">
                  Trusted Guidance
                </h4>
                <p className="text-sm text-[#6B7280]">
                  Expert advice tailored specifically to your investment goals.
                </p>
              </div>

            </div>

            {/* BUTTON */}
            <button onClick={() => navigate("/about-us")} className="mt-10 bg-[#45A301] hover:bg-[#3e9202] text-white px-8 py-2.5 rounded-lg flex items-center gap-2 transition ">
              Learn More About Us
              <FaArrowRightLong strokeWidth={1}/>
            </button>

          </div>
        </div>
      </div>
    </section>
  );
}